import React from 'react'
import { Box } from '@mui/material'

function CaptchaFooter() {
  return (
    <Box
      width='100%'
      sx={{
        fontSize: '9px',
        color: 'gray',
        textAlign: 'center'
      }}
    >
      This site is protected by reCAPTCHA and the Google
      <br />
      <a
        style={{ textDecoration: 'none' }}
        href='https://policies.google.com/privacy'
        target='_blank'
        rel='noreferrer'
      >
        Privacy Policy&nbsp;
      </a>
      and&nbsp;
      <a
        style={{ textDecoration: 'none' }}
        href='https://policies.google.com/terms'
        target='_blank'
        rel='noreferrer'
      >
        Terms of Service&nbsp;
      </a>
      apply.
    </Box>
  )
}

export default CaptchaFooter
